import React from 'react';
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import { ReactComponent as Logo } from '../assets/logo_white_full.svg';
import SocialButton from '../shared/social-button';
import style from './block.module.scss';

const SocialIcons = ({ settings }) => {
    const { facebookUrl, instagramUrl, youtubeUrl } = settings;

    return [
        facebookUrl && (
            <li key="facebook">
                <SocialButton socialNetwork={'facebook'} url={facebookUrl} backgroundColor={'white'} />
            </li>
        ),
        instagramUrl && (
            <li key="instagram">
                <SocialButton socialNetwork={'instagram'} url={instagramUrl} backgroundColor={'white'} />
            </li>
        ),
        youtubeUrl && (
            <li key="youtube">
                <SocialButton socialNetwork={'youtube'} url={youtubeUrl} backgroundColor={'white'} />
            </li>
        ),
    ];
};

function Block({ menu, menuBottom, settings = {} }) {
    return (
        <BlockWrapper.Footer className={style.block}>
            <div className={style.mainContainer}>
                <div className={style.mainMenu}>
                    <div className={style.content}>
                        <Logo className={style.logo} />
                        {menu && (
                            <nav className={style.menu}>
                                <ul>
                                    {Object.values(menu).map((item, i) => (
                                        <li className={style.section} key={i}>
                                            <a className={style.title} href={item.url}>
                                                {item.title}
                                            </a>
                                            <ul>
                                                {item.children?.map((subItem, j) => (
                                                    <li key={j}>
                                                        <a href={subItem.url}>{subItem.title}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        )}

                        <ul className={style.socials}>
                            <SocialIcons settings={settings} />
                        </ul>
                    </div>
                </div>

                <div className={style.bottom}>
                    <div className={style.content}>
                        <div className={style.copyright}>Copyright © 2022 Arcachon, tous droits réservés</div>
                        <ul className={style.list}>
                            {menuBottom &&
                                Object.values(menuBottom).map((item, i) => (
                                    <li key={i}>
                                        <a
                                            href={item.url}
                                            onClick={() =>
                                                item.url === '#axeptio_main_button' && window.openAxeptioCookies()
                                            }
                                        >
                                            {item.title}
                                        </a>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </div>
            </div>
        </BlockWrapper.Footer>
    );
}

export default defineBlock({
    Block,
    setup: {
        title: 'Footer',
    },
});
